/**
 * modal status
 */
export const upgradeModalStatus = (state) => state.upgradeModal.show;
export const upgradeModalURL = (state) => state.upgradeModal.url;
